import { useContext } from 'react';
import { fetchAudio } from '../hooks/audioService';
import VideoContext from '../context/VideoContext';
import AudioContext from '../context/AudioContext';

interface hookProps {
  urlId: string;
}

const useAudioDescBtn = ({ urlId }: hookProps) => {
  const { setVideoSrc, setIsVideo } = useContext(VideoContext);
  const { audioRef } = useContext(AudioContext);
  
  const handleAudio = async (urlId: any) => {
    try {
      const data = await fetchAudio(urlId);
      if (data.includes('.mp4')) {
        setVideoSrc(data);
        setIsVideo(true);
      } else {
        if (audioRef && audioRef.current) {
          audioRef.current.src = data;
          audioRef.current.currentTime = 0;
          audioRef.current.play();
        }
      }
    } catch(error:  any) {
      console.error(error.message);
    }
  };

  return handleAudio;
};

export default useAudioDescBtn;